import styled from 'styled-components';

import { ScrollableContainer } from '@web/components/ScrollableContainer/ScrollableContainer';

export const Wrapper = styled.div`
  & button[type] {
    width: 210px;
  }
`;

export const InnerWrapper = styled.div`
  margin: 0 -20px;
  position: relative;
`;

export const ScrollContainer = styled(ScrollableContainer)`
  display: flex;
  flex-flow: column nowrap;
  gap: 20px;
  max-height: 550px; // circa 9.5 Items
  // vertical "padding" is 20px
  // scrollbar track has 2px padding
  // we want to have 5px gap on the right side of the scrollbar
  // so 5px - scrollbar track:
  margin-right: 3px;
  // and right padding: 20px - scrollbar width (11px) - right gap:
  padding: 0 ${({ shouldApplyFallback }) => (shouldApplyFallback ? '20px' : '6px')} 0 20px;
`;

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  height: 32px;
  width: 32px;

  & > svg {
    object-fit: contain;
  }
`;

export const List = styled.ol`
  list-style: none;
  margin: -10px 0 0;
  padding: 0;
`;

export const ListItemSkeleton = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnGray};
  color: ${({ theme }) => theme.colors.gray};
  padding: 10px 5px;

  & > svg {
    display: block;
  }
`;
export const ListItem = styled(ListItemSkeleton)`
  display: grid;
  font-size: 12px;
  font-weight: 400;
  gap: 0 10px;
  grid-template:
    'avatar name' 1fr
    'avatar meta' 1fr / min-content 1fr;
  line-height: 19px;
`;
export const ItemAvatar = styled.div`
  align-self: center;
  grid-area: avatar;
`;
export const ItemName = styled.span`
  font-size: 14px;
  font-weight: 600;
  grid-area: name;
`;
export const ItemMeta = styled.span`
  grid-area: meta;
`;
